import urls from '../constants/urls';
import { processRolePercentages } from '../utils/charts/helper';

export const LOAD_DEFAULT_STATS_FAILED = 'charts/LOAD_DEFAULT_STATS_FAILED';
export const LOAD_DEFAULT_STATS_SUCCESS = 'charts/LOAD_DEFAULT_STATS_SUCCESS';
export const LOADING_DEFAULT_STATS = 'charts/LOADING_DEFAULT_STATS';

export const LOAD_DIRECTORY_VIEWS_FAILED = 'charts/LOAD_DIRECTORY_VIEWS_FAILED';
export const LOAD_DIRECTORY_VIEWS_SUCCESS =
  'charts/LOAD_DIRECTORY_VIEWS_SUCCESS';
export const LOADING_DIRECTORY_VIEWS = 'charts/LOADING_DIRECTORY_VIEWS';

export const LOAD_ROLES_FAILED = 'charts/LOAD_ROLES_FAILED';
export const LOAD_ROLES_SUCCESS = 'charts/LOAD_ROLES_SUCCESS';
export const LOADING_ROLES = 'charts/LOADING_ROLES';

export const LOAD_USAGE_FAILED = 'charts/LOAD_USAGE_FAILED';
export const LOAD_USAGE_SUCCESS = 'charts/LOAD_USAGE_SUCCESS';
export const LOADING_USAGE = 'charts/LOADING_USAGE';

export const LOADING_CHARTS_DATA = 'charts/LOADING_CHARTS_DATA';
export const LOAD_CHARTS_DATA_SUCCESS = 'charts/LOAD_CHARTS_DATA_SUCCESS';
export const LOAD_CHARTS_DATA_FAILED = 'charts/LOAD_CHARTS_DATA_FAILED';

const initialState = {
  defaultStats: {},
  directoryViews: {},
  roles: {},
  rolesPercentage: {},
  usage: {},

  failedLoadingDefaultStats: false,
  failedLoadingDirectoryViews: false,
  failedLoadingRoles: false,
  failedLoadingRolesPercentage: false,
  failedLoadingUsage: false,

  isLoadingDefaultStats: false,
  isLoadingDirectoryViews: false,
  isLoadingRoles: false,
  isLoadingRolesPercentage: false,
  isLoadingUsage: false,

  defaultStatsEmpty: false,
  directoryViewsEmpty: false,
  rolesPercentageEmpty: false,
  usageEmpty: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DEFAULT_STATS:
      return {
        ...state,
        isLoadingDefaultStats: true,
        failedLoadingDefaultStats: false,
        defaultStatsEmpty: false,
      };

    case LOAD_DEFAULT_STATS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingDefaultStats: false,
          failedLoadingDefaultStats: false,
          defaultStats: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingDefaultStats: false,
          defaultStatsEmpty: true,
        };
      }

    case LOAD_DEFAULT_STATS_FAILED:
      return {
        ...state,
        isLoadingDefaultStats: false,
        failedLoadingDefaultStats: true,
      };

    case LOADING_DIRECTORY_VIEWS:
      return {
        ...state,
        isLoadingDirectoryViews: true,
        failedLoadingDirectoryViews: false,
        directoryViewsEmpty: false,
      };

    case LOAD_DIRECTORY_VIEWS_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingDirectoryViews: false,
          failedLoadingDirectoryViews: false,
          directoryViews: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingDirectoryViews: false,
          directoryViewsEmpty: true,
        };
      }

    case LOAD_DIRECTORY_VIEWS_FAILED:
      return {
        ...state,
        isLoadingDirectoryViews: false,
        failedLoadingDirectoryViews: true,
      };

    case LOADING_ROLES:
      return {
        ...state,
        isLoadingRoles: true,
        failedLoadingRoles: false,
        rolesEmpty: false,
        isLoadingRolesPercentage: true,
        failedLoadingRolesPercentage: false,
        rolesPercentageEmpty: false,
      };

    case LOAD_ROLES_SUCCESS:
      if (action.payload.data) {
        const roles = action.payload.data;
        const rolesPercentage = processRolePercentages(roles);

        return {
          ...state,
          isLoadingRoles: false,
          failedLoadingRoles: false,
          isLoadingRolesPercentage: false,
          failedLoadingRolesPercentage: false,
          roles,
          rolesPercentage,
        };
      } else {
        return {
          ...state,
          isLoadingRoles: false,
          rolesEmpty: true,
          isLoadingRolesPercentage: false,
          rolesPercentageEmpty: true,
        };
      }

    case LOAD_ROLES_FAILED:
      return {
        ...state,
        isLoadingRoles: false,
        failedLoadingRoles: true,
        isLoadingRolesPercentage: false,
        failedLoadingRolesPercentage: true,
      };

    case LOADING_USAGE:
      return {
        ...state,
        isLoadingUsage: true,
        failedLoadingUsage: false,
        usageEmpty: false,
      };

    case LOAD_USAGE_SUCCESS:
      if (action.payload.data) {
        return {
          ...state,
          isLoadingUsage: false,
          failedLoadingUsage: false,
          usage: action.payload.data,
        };
      } else {
        return {
          ...state,
          isLoadingUsage: false,
          usageEmpty: true,
        };
      }

    case LOAD_USAGE_FAILED:
      return {
        ...state,
        isLoadingUsage: false,
        failedLoadingUsage: true,
      };

    case LOADING_CHARTS_DATA:
      return {
        ...state,
        isLoadingDirectoryViews: true,
        failedLoadingDirectoryViews: false,
        isLoadingDefaultStats: true,
        failedLoadingDefaultStats: false,
      };

    case LOAD_CHARTS_DATA_SUCCESS:
      if (action.payload.data) {
        const { data } = action.payload.data;
        const { usage_trend, defaulting_trend, directory_view_trend } = data;

        return {
          ...state,
          isLoadingUsage: false,
          failedLoadingUsage: false,
          isLoadingDirectoryViews: false,
          failedLoadingDirectoryViews: false,
          isLoadingDefaultStats: false,
          failedLoadingDefaultStats: false,
          usage: usage_trend,
          directoryViews: directory_view_trend,
          defaultStats: defaulting_trend,
        };
      } else {
        return {
          ...state,
          isLoadingUsage: false,
          usageEmpty: true,
          isLoadingDirectoryViews: false,
          directoryViewsEmpty: true,
          isLoadingDefaultStats: false,
          defaultStatsEmpty: true,
        };
      }

    case LOAD_CHARTS_DATA_FAILED:
      return {
        ...state,
        isLoadingUsage: false,
        failedLoadingUsage: true,
        isLoadingDirectoryViews: false,
        failedLoadingDirectoryViews: true,
        isLoadingDefaultStats: false,
        failedLoadingDefaultStats: true,
      };

    default:
      return state;
  }
};

export const loadChartsData = hospitalId => dispatch => {
  return dispatch({
    types: [
      LOADING_CHARTS_DATA,
      LOAD_CHARTS_DATA_SUCCESS,
      LOAD_CHARTS_DATA_FAILED,
    ],
    payload: {
      request: {
        url: urls.hospitals.charts.v3.data(hospitalId),
      },
    },
  });
};

export const loadRoles = hospitalId => dispatch => {
  return dispatch({
    types: [LOADING_ROLES, LOAD_ROLES_SUCCESS, LOAD_ROLES_FAILED],
    payload: {
      request: {
        url: urls.hospitals.charts.roles(hospitalId),
      },
    },
  });
};
